import {Component, Event, EventEmitter, h, Listen, Prop, State} from '@stencil/core';
import {endpoint_portal, language, translate} from '../../../utils/utils';
import {conditions} from '../../../utils/conditions';
import Infomaniak from '../../../assets/logo/infomaniak.svg';
import {isOnlyPurchaseTunnelActive, isPortalMigros, shopIntegrationState} from '../../../utils/store';

@Component({
  tag: 'ike-footer',
  styleUrl: 'ike-footer.scss',
  shadow: false,
})
export class IkeFooter {
  @Prop() lite = false;
  @State() config: any;
  @State() cart = null;
  @State() cartCount: any;
  @State() showCond = false;
  @State() showMentions = false;
  @State() shop = '/';

  @Event() getUtils: EventEmitter;

  private utils: any;
  private unsub = [];

  componentWillLoad(){
    this.getUtils.emit(utils=>this.utils=utils);

    this.unsub.push(this.utils.cart(cart => {
      this.cart = cart
      this.cartCount = this.cart?.normalTicketscount + this.cart?.passescount + (this.cart?.giftcount || 0) + (this.cart?.donationCount || 0)
    }));
    this.unsub.push(this.utils.config(config => this.config = config))

    this.shop = this.utils.route?.path;
    this.utils.observable.addEventListener('routeChanged', (event) => {
      this.shop = event.detail.route?.path
    });
  }

  disconnectedCallback(){
    this.unsub.forEach(call=>call())
  }

  private handleSelectLanguage(value) {
    const lang = (this.cart.interface_languages || Object.values(this.cart.all_languages)).filter(l=>l.sLocaleShort==value)[0].sLocaleShort
    language(lang)
    window.location.href = window.location.href
  }

  @Listen('closeIkeModal')
  handleCloseIkeModal() {
    this.showMentions = false;
  }

  render() {
    if (
      shopIntegrationState.isEmbedded &&
      !isOnlyPurchaseTunnelActive()
    ) {
      return this.renderEmbeddedFooter();
    } else if (!isOnlyPurchaseTunnelActive()) {
      return this.renderShopFooter();
    }
    return;
  }

  renderActions() {
    if (isPortalMigros()) {
      return;
    }

    return [
      this.config?.exchange_config && !this.shop.includes('exchange') &&
      <ike-link class="button primary btn-sm exchange hydrated" url='/exchange'>
        <i class="icon-tickets-exchange margin-right-10 main-color-text"></i>
        {translate("Echange de billets")}
      </ike-link>,

      this.config?.abo_renew_available && !this.shop.includes('pass-renew') &&
      <ike-link class="button primary btn-sm exchange hydrated" url='/pass-renew'>
        <i class="icon-abo margin-right-10 main-color-text"></i>
        {this.config?.passRenewText}
      </ike-link>,
    ];
  }

  renderShopFooter() {
    const realignActions: boolean = this.shop.includes('event') || this.shop.includes('events') || this.shop === '/';
    return (
      <div class="wrap">
        <div class={"flex gap-8 margin-top-50" + (realignActions ? ' margin-left-45' : '')}>
          {this.renderActions()}
        </div>
      </div>
    )
  }

  renderEmbeddedFooter() {
    return (
      <footer>
        <div class="wrap">
          {!this.lite &&
            <div class="footer-line">
              <h2 class="text-2">{translate("Besoin d'aide")}</h2>
              {this?.config?.period?.phone && !this?.config?.hidePhone &&
                <a href={"tel:" + this?.config?.period?.phone}>
                  <i class="icon-phone"/>{this?.config?.period?.phone}
                </a>
              }
              {this?.config?.period?.email &&
                <a href={"mailto:" + this?.config?.period?.email}>
                  <i class="icon-email-action-unread"/>{this?.config?.period?.email}
                </a>
              }
              {this.renderActions()}
            </div>
          }
          <div class="footer-line">
          <h2 class="text-2">{translate("Organisateur")}</h2>
          <p>
            {this?.config?.period?.orga_name}<br/>
            {this?.config?.period?.street}<br/>
            {this?.config?.period?.zipcode} {this?.config?.period?.city}
          </p>
          {this.config && !this.lite && [
            <p>
              <ike-link onClick={() => this.showCond = true}>{translate("Conditions generales de vente")}</ike-link>
              <ike-modal class="conditions" visible={this.showCond}>
                <div class="conditions--title">
                  <h2 class="title-3">{translate('Conditions generales de vente')}</h2>
                  <span class="conditions--close" onClick={()=>this.showCond=false}><i class="icon-close"/></span>
                </div>
                <div class="modal-content scroll-discreet" innerHTML={this.config?.condition || conditions()}/>
              </ike-modal>
              <br/><br/>
            </p>,
            <p>
              <ike-link onClick={() => this.showMentions = true}>{translate("Mentions legales")}</ike-link>
              <ike-modal visible={this.showMentions}>
                <h2 class="ike-modal-title title-3">
                  {translate("Mentions legales")}<span class="close" onClick={() => this.showMentions = false}><i class="icon-close"/></span>
                </h2>
                <p>
                  {translate("Tous les paiements effectues sur la billetterie sont securises et encaisses par {name_adress}, puis reverses a l'organisateur, selon les conditions contractuelles.", {
                    name_adress: "Infomaniak Entertainment SA, Rue Eugene-Marziano 25, 1227 Geneve, Suisse"
                  })}
                </p>
              </ike-modal>
            </p>
          ]}
        </div>
          {/*<div class="footer-line">*/}
          {/*  <h2 class="text-2">{translate('Suivez-nous')}</h2>*/}
          {/*  <div class="social">*/}
          {/*    <a href=""><i class="icon-facebook"/></a>*/}
          {/*    <a href=""><i class="icon-instagram"/></a>*/}
          {/*    <a href=""><i class="icon-twitter"/></a>*/}
          {/*    <a href=""><i class="icon-youtube"/></a>*/}
          {/*  </div>*/}
          {/*</div>*/}
          <div class="footer-line powered">
            <p class="text-4 powered_by">powered by &nbsp;<a target={'_blank'} href={`${endpoint_portal}`}><img
              src={Infomaniak} alt="Infomaniak"/></a></p>
          </div>
          <div class="footer-line footer-embeded">
            <div class="select-container">
              {this.cart?.currencies && !this.cart.furnished && this.cart?.currencies?.length > 1 && !this.lite &&
                <ike-dropdown placement="top" class="currencies">
                  <div slot="trigger" class="trigger button btn-cart">
                    {this.cart.currency.name} <i class="icon-chevron-down"/>
                  </div>
                  <div slot="content">
                    {this.cart.currencies.map(currency =>
                      <div class="dropdown__link" onClick={() => this.utils.handleSelectCurrency(currency.id, this.cart)}>
                        {currency.name}
                      </div>
                    )}
                  </div>
                </ike-dropdown>
              }
              {this.cart?.interface_languages && this.cart?.interface_languages?.length > 1 && !this.lite &&
                <ike-dropdown placement="top" class="languages">
                  <div slot="trigger" class="trigger button btn-cart">
                    {language() || this.cart.language.short} <i class="icon-chevron-down"/>
                  </div>
                  <div slot="content">
                    {this.cart.interface_languages.map(language =>
                      <div class="dropdown__link" onClick={() => this.handleSelectLanguage(language.sLocaleShort)}>
                        {language.sLocaleShort}
                      </div>
                    )}
                  </div>
                </ike-dropdown>
              }
            </div>
            <div class="only_embeded buttons-container">
              {this.config?.abo_available && !(this.cart?.customer && this.utils.storage.get('user_token')) &&
              <a onClick={() => {
                this.utils.goTo('/pass-access')
              }}>
                  <i class="icon icon-abo"/>
                {this.config?.passCodeText}
              </a>
              }
              {(!this.cart?.customer || !this.utils.storage.get('user_token')) &&
              <a onClick={() => {
                this.utils.goTo('/login')
              }}>
                  <i class="icon icon-single-neutral-circle" aria-label={translate('Se connecter')}/>
                {translate('Se connecter')}
              </a>
              }
            </div>
            <p class="text-4 powered_by only_embeded">powered by &nbsp;<a target={'_blank'} href={`${endpoint_portal}`}><img
              src={Infomaniak} alt="Infomaniak"/></a></p>
          </div>
        </div>
      </footer>
    );
  }
}
